import axios from "axios";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";

export const Axios = axios.create({
	/* baseURL: 'https://dev.apps.maine.edu/applymaine/rest/v1', */
	baseURL:
		typeof process.env.VUE_APP_API_URL === "undefined"
			? window.location.protocol +
			  "//" +
			  window.location.hostname +
			  ":" +
			  window.location.port +
			  "/applymaine/rest/v1"
			: process.env.VUE_APP_API_URL,
	withCredentials: true,
	timeout: process.env.VUE_APP_API_TIMEOUT
});
